import { z } from "zod";

export const phonePattern = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const maritalStatusValues = ["married", "single", "separated", "divorced", "widowed"] as const;
export const employmentStatusValues = ["employed", "self-employed", "unemployed"] as const;
export const employmentTypeValues = ["full-time", "part-time", "casual"] as const;
export const australianStates = ["NSW", "VIC", "QLD", "WA", "SA", "TAS"] as const;
export const applicantTypes = ["MainApplicant", "CoApplicant"] as const;

export const passwordSchema = z
  .string()
  .min(8, "At least 8 characters")
  .regex(/[A-Z]/, "At least one uppercase letter")
  .regex(/[a-z]/, "At least one lowercase letter")
  .regex(/[0-9]/, "At least one number")
  .regex(/\W/, "At least one special character");

export const passwordRules = [
  { label: "At least 8 characters", isMet: (password: string) => password.length >= 8 },
  { label: "An uppercase letter", isMet: (password: string) => /[A-Z]/.test(password) },
  { label: "A lowercase letter", isMet: (password: string) => /[a-z]/.test(password) },
  { label: "A number", isMet: (password: string) => /[0-9]/.test(password) },
  { label: "A symbol, like ! or #", isMet: (password: string) => /\W/.test(password) },
];
